import React from "react";
import { useNavigate } from "react-router-dom";
import "./ModuleCardCompact.css";
import { Button, Typography, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

const REACT_APP_STATIC_URL = process.env.REACT_APP_STATIC_URL;



const ModuleCardCompact = ({ module }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function getImgPath() {
    if (module) {
      return `${REACT_APP_STATIC_URL}/${module.imgPath}`;
    }
    return "";
  }

  return (
    <div className="module-card-compact">
      <img
        className="module-compact-img"
        src={getImgPath()}
        alt={module?.name || ""}
      />
      <div className="module-card-compact-content">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            sx={{ color: "#439BD9", fontWeight: 600, fontSize: "18px", marginBottom: "4px" }}
          >
            {t(`module.${module?.name}`)}{" "}
            {!module.available && <span>({t("binnenkort")})</span>}
          </Typography>

          <Typography variant="body2" sx={{ color: "#454545", fontSize: "14px" }}>
            {t(`module.${module?.name}_description`)}
          </Typography>
        </Box>

        <div className="module-card-compact-button">
          <Button
            size="small"
            onClick={() => navigate(module.redirectUri)}
            disabled={!module.available}
            sx={{ textTransform: "none", fontSize: "16px", fontWeight: 600 }}
            endIcon={<ArrowForwardIcon />}
          >
            {t("Start check")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModuleCardCompact;
